const chooseNeedInitialDropdownValues = {

 'saveForChildrenIncome':'1 Lac to 2 Lacs',
 'saveForChildrenLumpsum':'15 to 30 Lacs',

 'saveForRetirementIncome':'1 Lac to 2 Lacs',

 'growMyMoneyIncome':'1 Lac to 2 Lacs',
 'growMyMoneyLumpsum':'15 to 30 Lacs',

 'protectionForFamilyLumpsum':'1 Cr to 2 Cr',
 'protectionForHealthLumpsum':'20 Lacs'
}

export default chooseNeedInitialDropdownValues